import React from 'react'

import { Formik } from 'formik'

import { Button, Form, Modal } from '_zari/core'

import Yup from '_zari/validation/_yup'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  codigoPresupuesto: Yup.string().min(3).max(500).notRequired()
})

const ActualizarPresupuestoHandler = ({ handleClose, show, modalData, actualizarPresupuestoHandler }) => {
  const formInitialValues = React.useMemo(
    () => ({
      codigoPresupuesto: modalData.codigoPresupuesto || '',
      codigoPresupuestoInfo: modalData.codigoPresupuestoInfo || ''
    }),
    [modalData]
  )

  const submitHandler = async data => {
    actualizarPresupuestoHandler(data)
    handleClose()
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>ACTUALIZAR COMENTARIO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <FormGroups.CodigoPresupuestoFormGroup
                iError={errors.codigoPresupuesto}
                iTouched={touched.codigoPresupuesto}
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
                iValue={values.codigoPresupuestoInfo}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleClose}>Cancelar</Button>
              <Button onClick={handleSubmit}>Actualizar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(ActualizarPresupuestoHandler)
